import { SplitText } from "./dev.js";

let windowTablet = 991
let windowMobile = 768

let scroller;
if($('main.main').length) {
    scroller = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        getDirection: true
    });
}
const mm = gsap.matchMedia()

function dropdown(options) {
    let opts = {
        closeOnClick: true,
        timing: false,
        closeBtnClass: false,
        globalContainer: '',
        effect: 'fade'
    }
    let timing = 300;

    $.extend( opts, options );

    function open(e) {
        e.preventDefault()
        let container = $(this).closest('.'+opts.containerClass)
        let thisDropdown = container.find(opts.dropdownSelector)

        if(e.type === 'focusin')
            container.addClass('focusin')

        if((container.hasClass('is-open') || container.hasClass('disabled')) && !container.hasClass('focusin')){
            close()
            return;
        }

        if(e.type !== 'focusin')
            container.removeClass('focusin')

        close(container)

        container.addClass('is-open').css('z-index', '4')

        if(opts.effect === 'fade') {
            thisDropdown.fadeIn(timing)
        } else {
            thisDropdown.slideDown(timing)
        }
    }
    function close(dontClose = false) {
        let dropdownsToClose = $('.'+opts.containerClass)

        if(dontClose)
            dropdownsToClose = dropdownsToClose.not(dontClose)

        dropdownsToClose.find('li').removeClass('hover')

        dropdownsToClose.removeClass('is-open')

        if(opts.effect === 'fade') {
            dropdownsToClose.find(opts.dropdownSelector).fadeOut(timing)
        } else {
            dropdownsToClose.find(opts.dropdownSelector).slideUp(timing)
        }


        setTimeout(function () {
            dropdownsToClose.removeAttr('style')
        }, timing)
    }

    $(document).on('click', function (e) {
        let thisEl = $(e.target)

        if(opts.closeBtnClass ? thisEl.hasClass(opts.closeBtnClass) : false)
            close()
        if(!thisEl.hasClass(opts.containerClass) && (!thisEl.closest('.'+opts.containerClass).length))
            close()
    })
    $(document).on('click', opts.globalContainer+' .'+opts.containerClass +' '+ opts.btnSelector, open)
    $(document).on('focusin', opts.globalContainer+' .'+opts.containerClass +' '+ opts.btnSelector, open)
    $(document).on('focusout', opts.globalContainer+' .'+opts.containerClass +' '+ opts.btnSelector, function () {
        $(this).closest('.'+opts.containerClass).removeClass('focusin')
        close($(this).closest('.'+opts.containerClass))
    })
    $(document).on('close-dropdown', close)



    if(options.timing !== false)
        timing = options.timing;
    if(options.containerClass === 'select')
        timing = 0;

    if(opts.closeOnClick){
        $(document).on('click', opts.globalContainer+' .'+opts.containerClass +' '+opts.dropdownSelector, function () {
            if(!$(this).closest('.'+opts.containerClass).hasClass('checkbox'))
                close()
        })
    }
}

let isResizeSet = false;
function setResizeUpdate(){
    if(isResizeSet) return;
    let resizeTimeout = 0;

    $(window).on('resize', function () {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(function () {
            scroller.update()
        },300)
    })
}

function blocks() {
    let methods = {
        //main page
        '.s-promo-main': function () {
            setResizeUpdate()
        },
        '.s-occasion': function (section) {
            let allImg = section.find('[data-hover-img]')

            section.find('[data-hover]').on('mouseover', function () {
                if($(window).width() <= 991) return;
                let thisImg = section.find('[data-hover-img="'+$(this).attr('data-hover')+'"]')

                if(!thisImg.length) return;

                allImg.not(thisImg).css('opacity', '0')
                thisImg.css('opacity', '1')

                section.find('.section-img').attr('href', $(this).attr('href'))
            })
        },
        '.s-gifts': function (sections) {
            sections.each(function () {
                let section = $(this)
                let slider = section.find('.swiper')[0]
                let swiper = {destroyed: true}
                let arrowPrev = section.find('.swiper-arrows-prev')[0]
                let arrowNext = section.find('.swiper-arrows-next')[0]
                swiper = new Swiper(slider, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    speed: 600,
                    navigation: {
                        nextEl: arrowNext,
                        prevEl: arrowPrev,
                    },
                    breakpoints: {
                        769: {
                            slidesPerView: 4,
                        },
                        575: {
                            slidesPerView: 2,
                        },
                    }
                })

                swiper.on('slideChangeTransitionEnd', function () {
                    checkScroll()
                })

                // function checkWidth() {
                //     if($(window).width() >= 575) {
                //         if(swiper.destroyed) {
                //
                //             scroller.update()
                //         }
                //     } else {
                //         if(!swiper.destroyed) {
                //             swiper.destroy()
                //             scroller.update()
                //         }
                //     }
                // }
                //
                // checkWidth()
                // $(window).on('resize', checkWidth)
            })
        },
        '.s-stores': function () {
            setResizeUpdate()
        },

        //category
        '.s-shop-category': function (sections) {
            sections.each(function () {
                let filterInput = $('[name="filter"]')
                let defaultVal = $('[name="filter"]:checked').val()
                let cardsContainer = $(this).find('.s-shop-category__cards')
                let rowsTimeout = 0;
                let $grid = cardsContainer.isotope({
                    itemSelector: '.s-card',
                    percentPosition: true,
                    filter: defaultVal ? '.filter-'+defaultVal : '*'
                });

                function filter(e) {
                    let thisBtn = $(this)

                    if(typeof e.originalEvent === 'undefined')
                        thisBtn = e

                    let category = thisBtn.val()
                    let filterSelector = '.filter-'+category

                    if(category === '*')
                        filterSelector = '*'

                    $grid.isotope({ filter: filterSelector })

                    setTimeout(function () {
                        scroller.update()
                        checkScroll()
                        setTimeout(setRowLines, 500)
                    }, 300)
                }
                function setRowLines(){
                    let cards = cardsContainer.find('.s-card:not([style*="display"])')
                    let index = 0;
                    let isEven = 1
                    if(cards.first().hasClass('s-card--not-rounded'))
                        isEven = 0

                    cards.each(function () {
                        if(index % 2 === isEven){
                            $(this).addClass('s-card--not-rounded')
                            $(this).removeClass('s-card--rounded')
                        } else {
                            $(this).addClass('s-card--rounded')
                            $(this).removeClass('s-card--not-rounded')
                        }
                        index++;
                    })

                    checkScroll()
                    if($(window).width() <= windowMobile) return;
                    let cardsLength = cards.length - 3
                    let rows = Math.ceil(cardsLength / 3)

                    cardsContainer.find('.s-shop-category__divider').remove()

                    for (let i = 0; i < rows; i++) {
                        let rowHeight = 0;
                        for (let t = 0; t < 3; t++) {
                            let thisCard = cards.eq((i*3)+t)
                            let thisCardHeight = thisCard.outerHeight()

                            if(thisCardHeight > rowHeight)
                                rowHeight = thisCardHeight
                        }
                        cardsContainer.append('<span class="s-shop-category__divider" style="top: '+((i+1) * rowHeight)+'px"></span>')
                    }
                }

                setRowLines()
                filterInput.on('change', filter)
                $(window).on('resize', setRowLines)
                jQuery( window ).resize(function() {
                    setRowLines();
                });
            })

            dropdown({
                containerClass: 's-shop-category__sort-dropdown',
                btnSelector: '>span',
                closeBtnClass: '',
                dropdownSelector: 'ul',
                timing: 300
            })
        },

        //product page
        '.s-product': function (section) {
            let mainSlider = $('.s-product__slider-img')[0]
            let nextSlider = $('.s-product__slider-next')[0]
            let arrowPrev = section.find('.swiper-arrows-prev')[0]
            let arrowNext = section.find('.swiper-arrows-next')[0]

            let mainSwiper = new Swiper(mainSlider, {
                slidesPerView: 1,
                spaceBetween: 30,
            })
            let nextSwiper = new Swiper(nextSlider, {
                slidesPerView: 3.75,
                spaceBetween: 26,
                centeredSlides: 'true',
                centeredSlidesBounds: 'true',
                navigation: {
                  nextEl: arrowNext,
                  prevEl: arrowPrev,
                  }
            })

            $(nextSlider).find('.swiper-slide').on('click', function () {
                mainSwiper.slideTo($(this).index())
            })

            mainSwiper.params.control = nextSwiper;

            mainSwiper.on('slideChangeTransitionEnd', function () {
                checkScroll()
            })


            let options = $('.s-product__opt-select li')

            options.on('click', function () {
                let thisContainer = $(this).closest('.s-product__opt-select')
                let itemValue = $(this).attr('data-value');
                let variantName = $('#selected-variant-vars');
                thisContainer.find('input[type="hidden"]').val($(this).attr('data-value'));
                thisContainer.find('>span').text($(this).text());
                let allValues = [];
                const slides = mainSwiper.slides;
                const slidesNav = nextSwiper.slides;

                $('.s-product__main input[type="hidden"].selected-var').each(function() {
                  allValues.push($(this).val());
                });
                variantName.val(allValues.join(' / '));
                const selectValue = $('#custom_select_id option[data-variant-name="' + variantName.val() + '"]');
                if(selectValue) {
                  const variantImageId = selectValue.data('variant-image-id');
                  for (let i = 0; i < slides.length; i++) {
                    const slide = slides[i];
                    const attr = slide.getAttribute('data-variant-image-id');
                    // const attr = slide.getAttribute('data-variant-title');
                    if (attr == variantImageId) {
                      mainSwiper.slideTo(i);
                      nextSwiper.slideTo(i);
                    }
                  }
                }  
                
            })

            dropdown({
                containerClass: 's-product__opt-select',
                btnSelector: '>span',
                closeBtnClass: '',
                dropdownSelector: 'ul',
                timing: 300
            })

            setTimeout(function () {
                scroller.update()
            },300)


        },
        '.s-similar': function (sections) {
            sections.each(function () {
                let section = $(this)
                let slider = section.find('.swiper')[0]
                let arrowPrev = section.find('.swiper-arrows-prev')[0]
                let arrowNext = section.find('.swiper-arrows-next')[0]

                let swiper = new Swiper(slider, {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    speed: 600,
                    navigation: {
                        nextEl: arrowNext,
                        prevEl: arrowPrev,
                    },
                    breakpoints: {
                        769: {
                            slidesPerView: 4
                        },
                        575: {
                            slidesPerView: 2,
                            spaceBetween: 0
                        },
                    }
                })

                swiper.on('slideChangeTransitionEnd', function () {
                    checkScroll()
                })
            })
        },

        //post
        '.s-promo__bg': function () {
            setResizeUpdate()
        },
        '.s-similar-posts': function (sections) {
            sections.each(function () {
                let section = $(this)
                let slider = section.find('.swiper')[0]
                let arrowPrev = section.find('.swiper-arrows-prev')[0]
                let arrowNext = section.find('.swiper-arrows-next')[0]


                let swiper = new Swiper(slider, {
                    slidesPerView: 1,
                    spaceBetween: 1,
                    speed: 600,
                    navigation: {
                        nextEl: arrowNext,
                        prevEl: arrowPrev,
                    },
                })

                swiper.on('slideChangeTransitionEnd', function () {
                    checkScroll()
                })
            })
        },

        //store
        '.s-store-map': function (section) {

        },

        //common
        '.text-section': function (section) {
            let accBtns = section.find('.text-section__sidebar-inner>ul>li>a')

            function closeAccordions(accToClose) {
                let thisBody = accToClose.find('>ul')
                thisBody.slideUp(300)
                accToClose.removeClass('is-open')
            }
            function toggleAccordion() {
                let thisHead = $(this)
                let accordion = thisHead.closest('li')
                let thisBody = accordion.find('>ul')

                thisBody.slideToggle(300)
                accordion.toggleClass('is-open')

                //to close else
                let elseAccordions = accordion.closest('ul').find('li.is-open').not(accordion)
                closeAccordions(elseAccordions)

                setTimeout(function () {
                    scroller.update()
                }, 300)
            }

            accBtns.on('click', toggleAccordion)
        },
        '.s-input--select': function (selects){
            $('.s-input--select li').on('click', function () {
                let thisContainer = $(this).closest('.s-input--select')

                thisContainer.find('input[type="hidden"]').val($(this).attr('data-value'))
                thisContainer.find('input[type="text"]').val($(this).text())
            })
            dropdown({
                containerClass: 's-input--select',
                btnSelector: '>input[type="text"]',
                closeBtnClass: '',
                dropdownSelector: 'ul',
                timing: 300
            })
        },
        '.s-input--number': function () {
            let inpNumber = '.s-input--number'
            let inpNumberEl = '.s-input--number input'

            let minusBtn = '.s-input__number-minus'
            let plusBtn = '.s-input__number-plus'


            function loadCart() {
                // Create an XMLHttpRequest object
                const xhttp = new XMLHttpRequest();
  
                // Define a callback function
                xhttp.onload = function() {
                  // Here you can use the Data
                  jQuery('#cart-items').html(JSON.parse(xhttp.responseText)['cart-items']);
                  $('#cart-items').removeClass('in-process');
                }
  
                // Send a request
                xhttp.open('GET', '/?sections=cart-items', true);
                xhttp.send();
            }

            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            function updateCart(empty = false) {
                let quantityPlus = [];
                if(!empty) {
                    $('.s-cart .s-cart__item-quantity input').each(function() {
                        quantityPlus.push($(this).val());
                    });
                } else {
                    $('.s-cart .s-cart__item-quantity input').each(function() {
                        quantityPlus.push(0);
                    });
                }

                jQuery.post(window.Shopify.routes.root + 'cart/update.js', { updates: quantityPlus }, function(response) {
                //   let data = JSON.parse(response);
                //   let finalAmt = numberWithCommas(data.total_price/100);
                  loadCart();
                });
            }

            $(document).on('click', minusBtn, function (e) {
                e.preventDefault();
                let inputEl = $(this).closest(inpNumber).find('input');
                let thisVal = parseInt(inputEl.val());
                inputEl.val(thisVal - 1);
                    
                $('#cart-items').addClass('in-process');
                setTimeout(() => {
                    updateCart();
                }, 500);
            })
            $(document).on('click', '#empty-cart', function (e) {
                e.preventDefault();
                updateCart(true);
            });
            $(document).on('click', plusBtn, function (e) {
                e.preventDefault();
                let inputEl = $(this).closest(inpNumber).find('input');
                let thisVal = parseInt(inputEl.val())
                // if(thisVal < parseInt(inputEl.attr('max'))) {
                    inputEl.val(thisVal + 1);
                    $('#cart-items').addClass('in-process');
                    setTimeout(() => {
                        updateCart();
                    }, 500);
                // }
            })
            $(document).on('focusout', inpNumberEl, function () {
                    let inputEl = $(this)
                    let thisMin = (inputEl.attr('min') && parseInt(inputEl.attr('min')) >= 0) ? parseInt(inputEl.attr('min')) : 1
                    let thisMax = (inputEl.attr('max') && parseInt(inputEl.attr('max')) >= thisMin) ? parseInt(inputEl.attr('max')) : false
                    let thisVal = parseInt(inputEl.val())

                    if (!thisVal)
                        $(this).val(thisMin)
                    if (thisVal < thisMin)
                        $(this).val(thisMin)
                    if (thisMax && thisVal > thisMax)
                        $(this).val(thisMax)

                    setTimeout(() => {
                        updateCart();
                    }, 500);
                })
        },
        '.s-accordion': function (accordions) {
            let accBtns = accordions.find('.s-accordion__head')

            function closeAccordions(accToClose) {
                let thisBody = accToClose.find('.s-accordion__body')
                thisBody.slideUp(300)
                accToClose.removeClass('is-open')
            }
            function toggleAccordion() {
                let thisHead = $(this)
                let accordion = thisHead.closest('.s-accordion')
                let thisBody = accordion.find('.s-accordion__body')

                thisBody.slideToggle(300)
                accordion.toggleClass('is-open')

                setTimeout(function () {
                    scroller.update()
                }, 300)

                //to close else
                let elseAccordions = accordion.closest('.s-accordion-list').find('.s-accordion.is-open').not(accordion)
                closeAccordions(elseAccordions)
            }

            accBtns.on('click', toggleAccordion)
        },
        '.float-btn': function (btn) {
            let prevY = 0;
            scroller.on('scroll', function (e,r,t) {
                if(e.scroll.y < prevY){
                    btn.addClass('is-active')
                } else {
                    btn.removeClass('is-active')
                }
                prevY = e.scroll.y
            })
        },
        '.pointer-cursor': function (cursor) {
            let mouseY = 0;
            let mouseX = 0;
            let style = getComputedStyle(cursor[0]);
            let width = parseInt(style.minWidth.replace('px', '')) / 2

            if ($(window).width() > windowTablet) {
                !function () {
                    setTimeout(() => {
                        var $follower = cursor[0];
                        var posX = 0;
                        var posY = 0;

                        TweenMax.to({}, 0.01, {
                            repeat: -1,
                            onRepeat: function onRepeat() {
                                let speed = 5;
                                posX += (mouseX - posX) / speed;
                                posY += (mouseY - posY) / speed;
                                TweenMax.set($follower, {
                                    css: {
                                        left: posX,
                                        top: posY
                                    }
                                });
                            }
                        });
                        window.addEventListener('pointermove', function (e) {
                            mouseX = e.clientX - width;
                            mouseY = e.clientY - width;
                        });


                    }, 100)
                }();
            }
        },
        '[data-pointer-area]': function (area) {
            let cursor = $('.pointer-cursor')
            let btns = area.find('.s-button')

            area.hover(
                function () {
                    cursor.find('.pointer-cursor__label').text($(this).attr('data-pointer-area'))
                    cursor.addClass('pointer-cursor--visible')
                },
                function () {
                    cursor.removeClass('pointer-cursor--visible')
                }
            )
            if(!btns.length) return;
            btns.hover(
                function () {
                    cursor.removeClass('pointer-cursor--visible')
                },
                function () {
                    cursor.find('.pointer-cursor__label').text($(this).attr('data-pointer-area'))
                    cursor.addClass('pointer-cursor--visible')
                }
            )
        },
        '[data-scroll]': function (elements) {
            elements.each(function () {

            })
        },

        '.title-animation': function (allTitles) {
                const titles = gsap.utils.toArray('.title-animation>*')
                titles.forEach(title => {
                    let thisItalic = $(title).find('>*')
                    thisItalic.each(function () {
                        if($(this).html())
                            $(this).html($(this).html().replaceAll(' ', '&nbsp;'))
                    })

                    title.split = new SplitText(title, {
                        type: "chars, words",
                    });
                    $(title).find('.split-word').each(function () {
                        let thisWord = $(this)
                        thisItalic.each(function () {
                            if(thisWord.text().toLowerCase().replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-') === $(this).text().toLowerCase().replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-'))
                                thisWord.addClass('style-italic')
                        })
                    })
                })
                const chars = gsap.utils.toArray('.split-char')

                function animateTitle(el) {
                    const chars = gsap.utils.toArray('.split-char', el)
                    gsap.fromTo(chars, {
                        yPercent: 150,
                        rotation: 45,
                    }, {
                        duration: 0.3,
                        ease: "circ.out",
                        yPercent: 0,
                        rotation: 0,
                        stagger: 0.03,
                    })
                    setTimeout(function () {
                        $(el).addClass('animation-done')
                    }, 300)
                }
                gsap.set(chars, {
                    yPercent: 150,
                    rotation: 45,
                })

                allTitles.each(function () {
                    if($(this).hasClass('is-inview')){
                        animateTitle(this)
                    }
                })

                $(document).on('call', function (e,t,r) {
                    if($(r).hasClass('animation-going')){
                        return;
                    } else {$(r).addClass('animation-going')
                    }
                    if(t !== 'title-visible') return;

                    animateTitle(r)
                })




        },
        '.header': function (header) {

            scroller.on('scroll', function (e) {
                if(e.scroll.y > header.height()) {
                    header.addClass('is-scrolling')
                    jQuery('#shopify-section-header').addClass('visible')
                    if (e.direction === 'down') {
                        if(header.hasClass('is-top')) {
                            header.addClass('is-hidden')
                            jQuery('#shopify-section-header').addClass('hidden')

                            setTimeout(function () {

                                header.removeClass('is-top')
                                // jQuery('#shopify-section-header').addClass('visible')
                                jQuery('#shopify-section-header').addClass('hidden')
                            }, 10)
                        } else {
                            header.addClass('is-hidden')
                            jQuery('#shopify-section-header').addClass('hidden')
                        }
                    } else {
                        header.removeClass('is-hidden')
                        jQuery('#shopify-section-header').removeClass('hidden')
                    }
                } else if(e.scroll.y <= 3) {
                    header.addClass('is-top')
                    header.removeClass('is-scrolling')
                    jQuery('#shopify-section-header').removeClass('hidden')
                    jQuery('#shopify-section-header').removeClass('visible')
                }
            })
        },
        '.header__mob-menu': function (menu) {
            let openBtn = $('.header__burger')
            let animItems = $('.header__mob-menu__nav>ul>li, .header__mob-menu__links>*, .header__mob-menu__bottom')

            menu.css('height', menu.height() - $('.header').height())

            function delay(item, prevDelay) {
                setTimeout(() => {
                    item.addClass('is-active')
                }, 100 * prevDelay);
            }

            function toggleMenu() {
                if(menu.hasClass('is-open')){
                    $('.header').removeClass('menu-open')
                    scroller.start()
                    $('html').removeClass('overflow-hidden')
                    setTimeout(() => {
                        animItems.removeClass('is-active')
                    }, 200);
                } else {
                    $('.header').addClass('menu-open')
                    scroller.stop()
                    $('html').addClass('overflow-hidden')
                    setTimeout(function () {
                        animItems.each(function (i) {
                            delay($(this), i+1)
                        })
                    }, 300)

                }

                menu.toggleClass('is-open')
                openBtn.toggleClass('is-open')
            }

            $('.header__mob-menu__search').on('click', function () {
                $('.search-popup').fadeIn(300)
                $('.search-popup').find('input').focus()
            })
            $('.search-popup__close').on('click', function () {
                $('.search-popup').fadeOut(300)
            })

            openBtn.on('click', toggleMenu)
            dropdown({
                globalContainer: '.header__mob-menu__nav',
                containerClass: 'has-child',
                btnSelector: '>a',
                closeBtnClass: '',
                dropdownSelector: 'ul',
                effect: 'slide',
                timing: 300
            })
        }
    }



    $.each(methods, function (selector, callback) {
        if($(selector).length)
            callback($(selector))
    })
}
function isElementXPxInViewport(el) {
    if(!el) return false;
    let x = el.getBoundingClientRect().left;
    let y = el.getBoundingClientRect().top;
    let ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    let hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    let w = el.clientWidth;
    let h = el.clientHeight;
    return (
        (y < hw &&
            y + h > 0) &&
        (x < ww &&
            x + w > 0)
    );
}


function anchors() {
    $('a[href*="#"]').on('click', function (e) {
        e.preventDefault()
        let href = $(this).attr('href');
        let block = $('#'+href.split('#').pop());
        let headerEl = $('.header')

        if(block.length) {
            scroller.scrollTo(block[0]);
        }
    });
}
let dataScroll = $('[data-scroll-call="title-visible"], [data-scroll-call="text-visible"], .s-card[data-scroll]')
function checkScroll() {
    dataScroll.each(function () {
        if(this.classList.contains('is-scrolled') || !isElementXPxInViewport(this)) return;
        this.classList.add('is-scrolled')
        $(document).trigger('call', [this.getAttribute('data-scroll-call'), this])
    })
}
function scrollAnimations() {
    checkScroll()
    scroller.on('scroll', checkScroll)
    scroller.on('call', function (e, r, t) {
        if(e==='is-in-view' && !t.el.classList.contains('is-scrolled'))
            t.el.classList.add('is-scrolled')
    })
}

$(document).ready(function () {
    blocks()
    anchors()
    scrollAnimations()
    setTimeout(function () {
        scroller.update()
    }, 3000)


    $('.s-input--checkbox-wrapper input[type="checkbox"]').on('change', function() {
        let hiddenInput = $(this).parent().parent().parent().prev();
        var values = [];
        $('.s-input--checkbox-wrapper input[type="checkbox"]:checked').each(function() {
          values.push($(this).val());
        });
        hiddenInput.val(values.join(', '));
    });

    $('[name="checkout"]').on('click', function(e) {
      var gift = $('#Gift').val();
      var occasion = $('#Occasion').val();
      if(gift === '' || gift === null) {
        e.preventDefault();
        $('#error-for-gift').show();
      }
      if(occasion === '' || occasion === null) {
        e.preventDefault();
        $('#error-for-occasion').show();
      }
    });



    $('a[href*="openPopup-"], [class*="openPopup"]').on('click', function (e) {
        e.preventDefault()
        let href = $(this).attr('href');
        let thisPopup;

        if(href) {
            let hrefArr = href.split('-')
            hrefArr.shift()
            hrefArr = hrefArr.join('-')
            thisPopup = hrefArr
        } else {
            thisPopup = Array.from(this.classList).find(className => className.indexOf('openPopup-') === 0).replace('openPopup-', '')
        }

        if(thisPopup){
            e.preventDefault()
        } else {
            return;
        }

        thisPopup = '#'+thisPopup

        $.fancybox.open({
            src: thisPopup,
            type: '',
            opts: {},
        });

    });

});
